import { cva } from 'class-variance-authority';
import type { VariantProps } from 'class-variance-authority';

export { default as Avatar } from './Avatar.vue';
export { default as AvatarFallback } from './AvatarFallback.vue';
export { default as AvatarImage } from './AvatarImage.vue';
export { default as OrganizationAvatar } from './OrganizationAvatar.vue';

export const avatarVariant = cva(
  'inline-flex items-center justify-center font-normal text-foreground bg-secondary select-none shrink-0 overflow-hidden',
  {
    defaultVariants: {
      size: 'base',
    },
    variants: {
      shape: {
        circle: 'rounded-full',
        square: 'rounded',
      },
      size: {
        base: 'size-8 text-xs',
        lg: 'size-10 text-base',
        md: 'size-8 text-[0.7rem]',
        sm: 'size-6 text-[0.6rem]',
        xl: 'size-32 text-lg',
        xs: 'size-5 text-[0.5rem]',
      },
    },
  },
);

export type AvatarVariants = VariantProps<typeof avatarVariant>;
